<template>
  <Modal :show="show" :controlsAvaliable="true">
    <template #header>
      <div class="modal-header">Изменить комментарий</div>
    </template>
    <template #body>
      <textarea cols="50" rows="10" v-model="text"></textarea>
    </template>
    <template #footer>
      <button @click="saveComment">Сохранить</button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Modal,
  },
  props: {
    show: Boolean,
    initialText: String
  },
  watch: {
    initialText: {
      immediate: true, 
      handler (text) {
        this.text = text
      }
    }
  },
  data() {
    return {
      text: '',
      showSuccessMesage: false,
    }
  },
  methods: {
    saveComment(){
      this.$emit("onSaveComment", this.text)
    }
  }
}
</script>
  
<style scoped>
.modal-header {
  font-weight: bold;
  color: #0074B5;
}

.modal-list-item {
  display: flex;
  align-items: center;
  padding-top: 0.3rem;
}

.modal-list-item input {
  margin-right: 0.5rem;
}

.filter{
  display: flex;
  justify-content: space-between;
}

.filter select {
  width: 9rem;
  margin-left: 2rem;
}

.filter{
  margin-bottom: 1rem;
}

textarea{
  padding: 10px
}

p{
  max-width: 400px;
}

button{
  padding: 5px;
}
</style>
  